import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function MobileMenu() {
  const [openmenu, setOpenmenu] = useState(null);
  const [dropdownmenu, setDropdownmenu] = useState(false);
  const [openSubmenu, setOpenSubmenu] = useState(null);

  return (
    <div className='offcanvas offcanvas-start' id='offcanvasNavbar'>
      <div className='offcanvas-header'>
        {/* Logo Start */}
        <div className='logo'>
          <Link TO='/'>
            <img
              src='/assets/images/logo.png'
              width={172}
              height={45}
              alt='Logo'
            />
          </Link>
        </div>
        {/* Logo End */}
        <button type='button' className='close' data-bs-dismiss='offcanvas'>
          <span />
          <span />
        </button>
      </div>
      <div className='offcanvas-body'>
        <div className='mobile-menu offcanvas-menu'>
          <ul className='navbar-menu'>
            <li>
              <Link to='/'>Home</Link>
            </li>
            <li>
              <Link to='/'>SKIN TREATMENTS</Link>
              <span class='menu-icon'></span>
              <span
                onClick={() => {
                  setOpenmenu(openmenu != 'SKIN' ? 'SKIN' : null);
                }}
                class='menu-expand'
              ></span>
              <ul
                className='sub-menu'
                style={{ display: openmenu == 'SKIN' ? 'block' : 'none' }}
              >
                <li
                  onClick={() => {
                    setOpenSubmenu(
                      openSubmenu !== 'ANTI-AGING' ? 'ANTI-AGING' : null
                    );
                  }}
                >
                  <a href='#'>ANTI-AGING TREATMENT</a>
                  <span class='menu-icon'></span>
                  <span class='menu-expand'></span>
                  <ul
                    className='sub-menu'
                    style={{
                      display: openSubmenu === 'ANTI-AGING' ? 'block' : 'none',
                    }}
                  >
                    <li>
                      <Link to='/our-services/mesotherapy-for-skin'>
                        Mesotherapy for Skin
                      </Link>
                    </li>
                    <li>
                      <Link to='/our-services/dermal-filler-botox'>
                        Dermal Fillers & Botox
                      </Link>
                    </li>
                    <li>
                      <Link to='/our-services/lip-enhancement'>
                        Lip Enhancement
                      </Link>
                    </li>
                    <li>
                      <Link to='/our-services/chin-enhancement'>
                        Chin Enhancement
                      </Link>
                    </li>
                    <li>
                      <Link to='/our-services/hifu-treatment'>
                        HIFU Treatment
                      </Link>
                    </li>
                    <li>
                      <Link to='/our-services/thread-lift'>Thread Lift</Link>
                    </li>
                  </ul>
                </li>
                <li
                  onClick={() => {
                    setOpenSubmenu(openSubmenu !== 'FACIAL' ? 'FACIAL' : null);
                  }}
                >
                  <a href='#'>FACIAL TREATMENT</a>
                  <span class='menu-icon'></span>
                  <span class='menu-expand'></span>
                  <ul
                    className='sub-menu'
                    style={{
                      display: openSubmenu === 'FACIAL' ? 'block' : 'none',
                    }}
                  >
                    <li>
                      <Link to='/our-services/dermaplaning'>Dermaplaning</Link>
                    </li>
                    <li>
                      <Link to='/our-services/medifacial'>Medifacial</Link>
                    </li>
                    <li>
                      <Link to='/our-services/vampire-facial'>
                        Vampire Facial
                      </Link>
                    </li>
                    <li>
                      <Link to='/our-services/hydra-facial'>HydraFacial</Link>
                    </li>
                    <li>
                      <Link to='/our-services/chemical-peels'>
                        Chemical Peel
                      </Link>
                    </li>
                    <li>
                      <Link to='/our-services/photofacial'>Photofacial</Link>
                    </li>
                    <li>
                      <Link to='/our-services/pigmentation-removal'>
                        Pigmentation Removal
                      </Link>
                    </li>
                  </ul>
                </li>
                <li
                  onClick={() => {
                    setOpenSubmenu(openSubmenu !== 'ACNE' ? 'ACNE' : null);
                  }}
                >
                  <a href='#'>ACNE TREATMENT</a>
                  <span class='menu-icon'></span>
                  <span class='menu-expand'></span>
                  <ul
                    className='sub-menu'
                    style={{
                      display: openSubmenu === 'ACNE' ? 'block' : 'none',
                    }}
                  >
                    <li>
                      <Link to='/our-services/radio-frequency-treatment'>
                        Radio Frequency
                      </Link>
                    </li>
                    <li>
                      <Link to='/our-services/microneedling'>
                        Microneedling
                      </Link>
                    </li>
                    <li>
                      <Link to='/our-services/anti-acne-treatment'>
                        Anti-Acne Treatment
                      </Link>
                    </li>
                  </ul>
                </li>
                <li
                  onClick={() => {
                    setOpenSubmenu(
                      openSubmenu !== 'REJUVENATION' ? 'REJUVENATION' : null
                    );
                  }}
                >
                  <a href='#'>SKIN REJUVENATION</a>
                  <span class='menu-icon'></span>
                  <span class='menu-expand'></span>
                  <ul
                    className='sub-menu'
                    style={{
                      display:
                        openSubmenu === 'REJUVENATION' ? 'block' : 'none',
                    }}
                  >
                    <li>
                      <Link to='/our-services/carbon-laser-treatment'>
                        Carbon Laser Treatment
                      </Link>
                    </li>
                    <li>
                      <Link to='/our-services/laser-toning-treatment'>
                        Laser Toning
                      </Link>
                    </li>
                  </ul>
                </li>
                <li
                  onClick={() => {
                    setOpenSubmenu(
                      openSubmenu !== 'WELLNESS' ? 'WELLNESS' : null
                    );
                  }}
                >
                  <a href='#'>WELLNESS</a>
                  <span class='menu-icon'></span>
                  <span class='menu-expand'></span>
                  <ul
                    className='sub-menu'
                    style={{
                      display: openSubmenu === 'WELLNESS' ? 'block' : 'none',
                    }}
                  >
                    <li>
                      <Link to='/our-services/glutathione-drip'>
                        Glutathione IV Drip
                      </Link>
                    </li>
                    <li>
                      <Link to='/our-services/nad-drip-therapy'>
                        NAD IV Drip Therapy
                      </Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link to='/our-services/laser-hair-reduction'>
                    Laser Hair Reduction
                  </Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to='#'>HAIR & AYURVEDIC TREATMENTS</Link>
              <span class='menu-icon'></span>
              <span
                onClick={() => {
                  setOpenmenu(openmenu != 'HAIR' ? 'HAIR' : null);
                }}
                class='menu-expand'
              ></span>
              <ul
                className='sub-menu'
                style={{ display: openmenu == 'HAIR' ? 'block' : 'none' }}
              >
                <li>
                  <Link to='/our-services/mesotherapy-for-hair'>
                    Mesotherapy for hair
                  </Link>
                </li>
                <li>
                  <Link to='/our-services/gfctherapy-for-hair'>
                    GFC Therapy
                  </Link>
                </li>
                <li>
                  <Link to='/our-services/exosomes-therapy-for-hair'>
                    Exosomes Therapy
                  </Link>
                </li>
                <li>
                  <Link to='/our-services/qr678-hair-therapy'>
                    Qr678 Therapy
                  </Link>
                </li>

                <li>
                  <Link to='/our-services/hairfall-treatment'>
                    Hair Fall Treatment
                  </Link>
                </li>
                <li>
                  <Link to='/our-services/hair-prp-therapy'>
                    Hair PRP Therapy
                  </Link>
                </li>
                <li>
                  <Link to='/our-services/ayurvedic-treatment'>
                    Ayurvedic Treatments
                  </Link>
                </li>
              </ul>
            </li>
            <li>
              <a href='#'>Mommy Makeover</a>
              <span class='menu-icon'></span>

              <span
                onClick={() => {
                  setOpenmenu(openmenu != 'MOMMY' ? 'MOMMY' : null);
                }}
                class='menu-expand'
              ></span>
              <ul
                className='sub-menu'
                style={{ display: openmenu == 'MOMMY' ? 'block' : 'none' }}
              >
                <li>
                  <Link to='/our-services/slimming-inch-loss-treatment'>
                    Slimming & Inch Loss
                  </Link>
                </li>
                <li>
                  <Link to='/our-services/cryolipolysis'>Cryolipolysis</Link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div className='mobi text-center'>
          <a
            href='#'
            className='btn appoin'
            data-bs-toggle='modal'
            data-bs-target='#staticBackdrop'
          >
            BOOK AN APPOINTMENT
          </a>
        </div>
      </div>
    </div>
  );
}

export default MobileMenu;
